import useAuth from "../../../hooks/useAuth";
import useData from "../../../hooks/useData";
import {useEffect, useState} from "react";
import {getBillingSettings} from "../../../api/admin/billingReq";
import Header from "../../../components/common/Header";
import Icon from "../../../components/common/Icon";
import {Link} from "react-router-dom";
import FormBillingSettings from "../../../forms/admin/billing/FormBillingSettings";

export default function ViewBillingSettings() {
    const { auth } = useAuth();
    const token = auth.token;
    const { billingSettings, setBillingSettings} = useData();

    const apiBillingSettings = async () => {
        const response = await getBillingSettings(token)
        setBillingSettings(response)

    }
    const [ showModal, setShowModal ] = useState(false);
    useEffect(() => {
        apiBillingSettings();
    }, []);

    const handleBillSettingsForm = (e) => {
        setShowModal(true)
    }

    const tabSources = "fa fa-bars"

    return (
        <main className="admin">
            <Header
                parent="Administration"
                location="Facturation"
                slug="/admin/accueil"
            />
            { showModal &&
                <div className="modal settings-modal">
                    <FormBillingSettings apiSettingsInfos={apiBillingSettings} setShowModal={setShowModal} legend="Paramètres de facturation"/>
                </div>
            }
            <nav className="tabs-menu">
                <ul>
                    <li><Link to="/admin/facturation">Forfait</Link></li>
                    <li><Link to="">Défunt</Link></li>
                    <li className="active"><Link to="/admin/facturation/parametres">Paramètres</Link></li>
                </ul>
            </nav>
            <div className="flex">
                <section className="settings">
                    <div className="flex">
                        <div className="column">
                            <div className="column">
                                <legend>Contact - Adresse</legend>
                                <i className="fa fa-pen-to-square" onClick={handleBillSettingsForm}></i>
                                <div className="form-input">
                                    <label>Nom de la société</label>
                                    <span>{billingSettings?.name}</span>
                                </div>
                                <div className="form-input">
                                    <label>Téléphone</label>
                                    <span>{billingSettings?.phone}</span>
                                </div>
                                <div className="form-input">
                                    <label>E-mail</label>
                                    <span>{billingSettings?.email}</span>
                                </div>
                                <div className="form-input">
                                    <label>Adresse</label>
                                    <span>{billingSettings?.address}</span>
                                </div>
                                <div className="form-input">
                                    <label>Complément</label>
                                    <span>{billingSettings?.addressComp}</span>
                                </div>
                                <div className="form-input">
                                    <label>Code postal</label>
                                    <span>{billingSettings?.zipcode}</span>
                                </div>
                                <div className="form-input">
                                    <label>Ville</label>
                                    <span>{billingSettings?.city}</span>
                                </div>
                            </div>
                        </div>
                        <div className="column">
                            <div className="column">
                                <legend>Juridique - Comptabilité</legend>
                                <i className="fa fa-pen-to-square" onClick={handleBillSettingsForm}></i>
                                    <div className="form-input">
                                        <label>Forme juridique</label>
                                        <span>{billingSettings?.legalForm}</span>
                                    </div>
                                    <div className="form-input">
                                        <label>Capital</label>
                                        <span>{billingSettings?.capital}</span>
                                    </div>
                                    <div className="form-input">
                                        <label>Siren</label>
                                        <span>{billingSettings?.siren}</span>
                                    </div>
                                    <div className="form-input">
                                        <label>RCS (ville)</label>
                                        <span>{billingSettings?.rcsCity}</span>
                                    </div>
                                    <div className="form-input">
                                        <label>Code APE</label>
                                        <span>{billingSettings?.ape}</span>
                                    </div>
                                    <div className="form-input">
                                        <label>Numéro ORIAS</label>
                                        <span>{billingSettings?.orias}</span>
                                    </div>
                                    <div className="form-input">
                                        <label>TVA intracommunautaire</label>
                                        <span>{billingSettings?.tvaIntra}</span>
                                    </div>
                                    <div className="form-input">
                                        <label>Taux TVA</label>
                                        <span>{billingSettings?.tvaRate},00%</span>
                                    </div>
                            </div>
                            <div className="column">
                                <legend>Banque</legend>
                                <i className="fa fa-pen-to-square" onClick={handleBillSettingsForm}></i>
                                <div className="form-input">
                                    <label>Numéro de compte</label>
                                    <span>{billingSettings?.account}</span>
                                </div>
                                <div className="form-input">
                                    <label>RIB</label>
                                    <span>{billingSettings?.ribKey}</span>
                                </div>
                                <div className="form-input">
                                    <label>IBAN</label>
                                    <span>{billingSettings?.iban}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </main>
    )
}